import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { CheckCircle } from 'lucide-react';
import { FAQCategory } from '../../utils/types';

interface FAQCardProps {
  category: FAQCategory;
}

const FAQCard = ({ category }: FAQCardProps) => {
  const IconComponent = category.icon;

  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <IconComponent className="h-5 w-5 text-primary" />
          </div>
          <CardTitle className="text-lg">{category.title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <ul className="space-y-3">
          {category.questions.map((question, index) => (
            <li key={index} className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-green-500 mt-0.5 flex-shrink-0" />
              <span className="text-sm text-foreground">{question}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default FAQCard;
